import moment from 'moment';
import Vue from 'vue';

export default Vue.component('daterange', {
    template:`
    <div class="form-group form-group-sm">
        <label class="font-size-sm" :for="fromId">{{label}}</label>
        <div class="input-daterange input-group">
            <input :id="fromId" :value="formatDate(dateFrom)" ref="dateFrom" class="form-control form-control-sm" :placeholder="placeholder" type="text"/>
            <div class="input-group-prepend input-group-append">
                <span class="input-group-text">
                    <i class="fa-xs si si-arrow-right"></i>
                </span>
            </div>
            <input :id="toId" :value="formatDate(dateTo)" ref="dateTo" class="form-control form-control-sm" :placeholder="placeholder" type="text"/>
        </div>
    </div>  
    `,
    props:{
        id: { type: String, default: null }, 
        dateFrom: String,
        dateTo: String,
        label: String,
        placeholder: { type: String, default: 'Select a date' }
    },
    computed:{
        fromId() {
            return this.id !== null ? `from-${this.id}` : `from-${this._uid}`;
        },
        toId() {
            return this.id !== null ? `to-${this.id}` : `to-${this._uid}`;
        }
    },
    methods:{
        formatDate(date){
            return date !== undefined && date !== null ? moment(date, moment.ISO_8601).format('L') : '';
        },
        parseDate(value){
            return moment(value, 'L');
        },
        getFromDate(value){
            var date = this.parseDate(value);
            return date.isValid() ? date.startOf('day').toISOString(true) : null;
        },
        getToDate(value){
            var date = this.parseDate(value);
            return date.isValid() ? date.endOf('day').toISOString(true) : null;
        },
        getDatePickerFormatPattern(){
            return moment.localeData()._longDateFormat.L.toLowerCase();
        }
    },
    mounted(){
        var formatPattern = this.getDatePickerFormatPattern();

        window.$(this.$refs.dateFrom).datepicker({
            weekStart: 1,
            autoclose: true,
            todayHighlight: true,
            language: document.documentElement.lang,
            clearBtn: true,
            format: formatPattern
        }).on('change.dp', (e) => { 
            this.$emit('update:dateFrom', this.getFromDate(e.target.value)); 
        });

        window.$(this.$refs.dateTo).datepicker({
            weekStart: 1,
            autoclose: true,
            todayHighlight: true,
            language: document.documentElement.lang,
            clearBtn: true,
            format: formatPattern
        }).on('change.dp', (e) => {
            this.$emit('update:dateTo', this.getToDate(e.target.value));
        })
    }
});